/* AMO Draft 04 — minimal theme JS (vanilla) */
(function () {
  'use strict';

  // ----- mobile drawer -----
  var drawer = document.querySelector('[data-drawer]');
  var scrim = document.querySelector('[data-scrim]');
  function openDrawer(o) {
    if (!drawer) return;
    drawer.classList.toggle('open', o);
    if (scrim) scrim.classList.toggle('open', o);
    document.body.style.overflow = o ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-burger]')) { e.preventDefault(); openDrawer(true); }
    if (e.target.closest('[data-drawer-close]') || e.target === scrim) openDrawer(false);
  });

  // ----- product gallery thumbnails -----
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var main = document.querySelector('[data-gmain]');
    if (main) { main.style.backgroundImage = "url('" + t.dataset.thumb + "')"; }
  });

  // ----- variant picker (select drives price + id) -----
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      if (!form) return;
      var priceEl = form.parentElement.querySelector('[data-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      var btn = form.querySelector('[data-atc]');
      if (btn) {
        var avail = opt.dataset.available === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? 'Add to cart' : 'Sold out';
      }
    });
  });

  // ----- cart qty steppers (submit the cart form) -----
  // Scoped to the cart form only: product forms (/cart/add) have their own steppers, and
  // binding them here made +/- on a product page add the item to the cart.
  document.querySelectorAll('form[action$="/cart"] [data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.step === 'up' ? 1 : -1;
        var v = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = v;
        var form = input.closest('form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  });
})();
